module.exports = __webpack_public_path__ + "img/hlw.d4f766b0.png";